import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Alert from "@material-ui/lab/Alert";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Spinner,
  Layer,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Catalog,
  Favorite,
  Blog,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Article,
  Contact,
  //DocumentPdf,
  SearchAdvanced,
  ChatOption,
  WeChat,
  Android,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import avtarPlaceholder from "../assets/user_placeholder.png";
import LoginSet from "../App";
import DocumentHandler from "./DocumenHandler";
import { auth } from "./Security/Auth";
import {
  APIServerURL,
  callApiGetJson,
  callApiPostJson,
  logAccess,
  UIServerURL,
} from "./GlobalSettings";

import allDemosbg from "../assets/allDemosbg.jpg";
import aigeneric from "../assets/aigeneric.JPG";
import hpeai_1 from "../assets/hpeai_1.jpg";
import engageCICBriefingbg from "../assets/engageCICBriefingbg.jpg";
import greenLakeDemosbg from "../assets/greenLakeDemosbg.jpg";
import partnerSolutionBG from "../assets/partnerSolutionBG.jpg";
import Alldemos from "../assets/ALLdemos.jpg";
import AIdemos from "../assets/AIdemos.jpg";
import GreenLakeDemos from "../assets/GreenLake_Demos.jpg";
import PartnerSolutions from "../assets/PartnerSolutions.jpg";
import { setTaxonomyDataRequest } from "../actions/TaxonomyActions";
import AppHeader from "./AppHeader";
import UserdashboardUpcomingDemos from "./UserdashboardUpcomingDemos";
import ListView from "./ListView";
import GetHelp from "./GetHelp";
import MMContentDetail from "./MMContentDetail";
import { SyncLoader } from "react-spinners";
import Chatapplet from "./Chatapplet";
import SearchHandler from "./SearchHandler";
import RatingFeedback from "./RatingFeedback";
import ChatappletN from "./ChatappletN";
import RedeemPopup from "./RedeemPopup";

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userInformation: auth.getUserInfo(),
      UpcomingEventsData: undefined,
      RecentEvtnMMsByUsr: undefined,
      isRecentEvtsMMs: false,
      FName: "",
      LName: "",
      img: "",
      email: "",
      isUsr_NLSub: auth.getUserInfo().IsNL_Subscribed ? true : false,
      isUsr_Redeem_Voucher_Req: auth.getUserInfo().Is_Redeem_Needed
        ? true
        : false,
      isProfileRefreshing: false, // Tracks the second API call state
      isReadyForRedirect: false,
      refDemoId: 0,
      refreshMessage: "", // Holds the custom spinner text
      disable: true,
      NLsubLoader: false,
      hasTaxDataLoaded: false,
      bOpenChat: false,
      bOpenChatViaLink: false,
      loadedTaxoData: null,
      showUpcomingEvtLoader: false,
      showUpcomingMainView: false,
      searchValueToBe: undefined,
      bPopupListView: false,
      bPopUpLV_Static: false,
      Static_CP_SrchObj: {
        MetadataID: "PRD_65fea4c8-5d7a-4b29-91b0-e2d7bb047fc6",
        MetadataName: "Recommended Contents",
        MetadataType: "Products",
      },
      bIsFavouriteClicked: false,
      isReqViaSrchDeepLink: false,
      isDeeplinkSearchByDemoId: false,
      SrchDeepLinkParam: undefined,
      isHelpModuleRequested: false,
      openDocument: false,
      openNewUIDoc: false,
      BannerLoading: true,
      SettingData: undefined,
      isNotificationON: true,
      showloaderforTaxonomy: false,
      toforceOpenPopUp: false,

      // SystemData: undefined,
      // IsBannerInfoViewed: false
      //VRNetLaunchData: undefined,
    };

    this._logout = this._logout.bind(this);
    this.loadUpcomingEventsData = this.loadUpcomingEventsData.bind(this);
    this._hideUpcomingView = this._hideUpcomingView.bind(this);
    this.hideRedeemPopup = this.hideRedeemPopup.bind(this);
    this.handleRedeemSuccessData = this.handleRedeemSuccessData.bind(this);
    this._showUpcomingView = this._showUpcomingView.bind(this);
    this.handleWhatsNew = this.handleWhatsNew.bind(this);
    this.closeList = this.closeList.bind(this);
    this.handleHowtoUse = this.handleHowtoUse.bind(this);
    this.handleEngageForBriefing = this.handleEngageForBriefing.bind(this);
    this.handleGreenLake = this.handleGreenLake.bind(this);
    this.handleCorePortfolio = this.handleCorePortfolio.bind(this);
    this.handleFavouriteClicked = this.handleFavouriteClicked.bind(this);
    this.onHpeGrowth7Click = this.onHpeGrowth7Click.bind(this);
    this.onCustAcclPlaysClick = this.onCustAcclPlaysClick.bind(this);
    this.onAIClick = this.onAIClick.bind(this);
    this.onHpeGreenLakeClick = this.onHpeGreenLakeClick.bind(this);
    this.closeHelpModule = this.closeHelpModule.bind(this);
    this.kickout = this.kickout.bind(this);
    this._handleDocumentView = this._handleDocumentView.bind(this);
    this._handleNewUIDocOpen = this._handleNewUIDocOpen.bind(this);
    this._CloseNewUIDocOverlay = this._CloseNewUIDocOverlay.bind(this);
    this._handleNavigateInterfaceDocView =
      this._handleNavigateInterfaceDocView.bind(this);
    this._pullNewsLetterLink = this._pullNewsLetterLink.bind(this);
    this.loadRecentEvtsMM = this.loadRecentEvtsMM.bind(this);
    this._CloseOverlay = this._CloseOverlay.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.OnNLsubClick = this.OnNLsubClick.bind(this);
    this._openchatApplet = this._openchatApplet.bind(this);
    this._openchatApplet_Link = this._openchatApplet_Link.bind(this);
    this.hidechat = this.hidechat.bind(this);
    this.OpenSlackHDPEmp = this.OpenSlackHDPEmp.bind(this);
    this.OpenSlackHDPPartner = this.OpenSlackHDPPartner.bind(this);
    this.OpenPSNow = this.OpenPSNow.bind(this);
    this.OpenTechPro = this.OpenTechPro.bind(this);
    this.handleRatingFeedbackClick = this.handleRatingFeedbackClick.bind(this);
    this.hideEvtsMMsPopup = this.hideEvtsMMsPopup.bind(this);
    /*     this.getSystemSettingsData = this.getSystemSettingsData.bind(this);
    this.extractBannerMsg = this.extractBannerMsg.biund(this); */
    // this.loadVRNetLaunchInfo = this.loadVRNetLaunchInfo.bind(this);
  }

  componentDidMount() {
    // document.body.style.overflow = "hidden";
    if (!auth.loggedIn || auth.getUserInfo() === undefined) {
      this.props.history.push("/");
    }

    if (auth.isAuthenticated && auth.getUserInfo() !== undefined) {
      if (
        auth.getUserInfo().TimeZone === null ||
        auth.getUserInfo().UserLocation === null
      ) {
        localStorage.removeItem("token");
        localStorage.removeItem("tokenexpires");
        localStorage.removeItem("email");
        localStorage.removeItem("userinfo");
        localStorage.removeItem("authenticated");
        localStorage.removeItem("userimgData");
        console.log("forced logged out or Kicked out");
        this.props.history.push("/");
      }
    }

    if (auth.getSearchParam() && auth.getSearchParam().length > 3) {
      var srchParam = auth.getSearchParam();
      if (srchParam.toLowerCase() === "gethelp") {
        this.setState({ isHelpModuleRequested: true });
      } else {
        this.setState({
          isReqViaSrchDeepLink: true,
          SrchDeepLinkParam: srchParam,
        });
      }
    }

    if (auth.getSearchdemoidParam() && auth.getSearchdemoidParam().length > 3) {
      var srchParam = auth.getSearchdemoidParam();
      this.setState({
        isReqViaSrchDeepLink: true,
        isDeeplinkSearchByDemoId: true,
        SrchDeepLinkParam: srchParam,
      });
    }

    console.log(localStorage.getItem("email"));
    var uinfo = JSON.parse(localStorage.getItem("userinfo"));
    console.log(uinfo);
    //console.log(uinfo.FirstName);
    //console.log(uinfo.LastName);
    const token = auth.getToken();
    var recEvtMMcounter = auth.getRecentEvtsMMPopUpCounter();
    // this.getSystemSettingsData();
    if (token) {
      this.getTaxonomyData(token);
    }
    //if (uinfo.UserActionsList.Content.ScheduleEvent) {
    if (token) {
      this.loadUpcomingEventsData();
    }

    if (token && !recEvtMMcounter && recEvtMMcounter !== "yes") {
      this.loadRecentEvtsMM();
    }

    if (token) {
      this._pullNewsLetterLink();
    }

    console.log("Auth getT1Cat is ", auth.getT1CategoryParam());
    // console.log("Taxonomy Data Disabled state  is ", this.state.disable);

    // this.loadVRNetLaunchInfo();
    // }
  }

  /*   loadVRNetLaunchInfo() {
    var endpoint = "/Events/GetVRNetLaunchInfo";
    let token = auth.getToken();
    callApiGetJson(endpoint, token).then((data) => {
      //console.log('VRNetLaunchinf data from API:', data);
      this.setState({
        VRNetLaunchData: data,
      });
    });
  } */

  kickout() {
    if (!auth.loggedIn || auth.getUserInfo() === undefined) {
      this.props.history.push("/");
    }
  }

  handleRatingFeedbackClick() {
    localStorage.removeItem("recentpopup");
    this.loadRecentEvtsMM();
    // this.setState({ toforceOpenPopUp: true });
  }

  OpenSlackHDPEmp() {
    window.open(
      "https://engage.cloud.microsoft/main/org/hpe.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyNTE1MTA0ODA4OTYifQ",
      "_blank",
    );
  }

  OpenSlackHDPPartner() {
    window.open(
      "https://hpe.enterprise.slack.com/archives/C07UW6H11LJ",
      "_blank",
    );
  }

  OpenPSNow() {
    console.log("Open PSNow clicked fired !!");
    window.open("https://psnow.ext.hpe.com", "_blank");
  }

  OpenTechPro() {
    console.log("Open TechPro clicked fired !!");
    window.open("https://techpro.hpe.com", "_blank");
  }

  _openchatApplet() {
    this.setState({ bOpenChat: true });
  }

  _openchatApplet_Link() {
    this.setState({ bOpenChatViaLink: true });
  }

  hidechat() {
    this.setState({ bOpenChat: false, bOpenChatViaLink: false });
  }

  closeNotification() {
    auth.setNotificationCounter(1);
    this.setState({ isNotificationON: false });
  }

  OnNLsubClick(value) {
    console.log("On NL sub YES Clicked with value ", value);
    this.setState({ NLsubLoader: true });
    var profData = {
      EmailAddress: this.state.userInformation.EmailAddress,
      Company: this.state.userInformation.Company, //companyValue
      TimeZone: {
        Timezone_ID: this.state.userInformation.TimeZone.Timezone_ID,
      },
      LearnerID: this.state.userInformation.LearnerID,
      IsNL_Subscribed: value,
      Job: null,
      /* "Job": {
              "JobID": jobRoleValue
          },*/
      UserLocation: {
        LocationID: this.state.userInformation.UserLocation.LocationID,
      },
    };
    var endpoint = "/Account/UpdateUserProfile";
    let token = auth.getToken();
    var postData = profData;
    console.log(
      "Profile request data for user NL subscription update :",
      profData,
    );
    // this.setState({ showLoader: true });
    //start below
    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log("Profile result data from API:", data);
      if (data) {
        console.log("UpdateMessage: ");
        console.log(data.UpdateMessage);
        auth.updateUserInfo(data);
        this.setState({ isUsr_NLSub: true, NLsubLoader: false });
      }
    });
  }

  _handleDocumentView() {
    console.log("View NewsLetter Document Clicked !!");
    this.setState({ openDocument: true });
  }

  _handleNewUIDocOpen() {
    console.log("View How To Use New UI Document Clicked !!");
    this.setState({ openNewUIDoc: true });
  }

  _handleNavigateInterfaceDocView() {
    console.log("View Navigate New User Interface Document Clicked !!");
  }

  handleRedeemSuccessData(resp) {
    console.log(
      "User Voucher Redeem Call Returned from RedeemPopup Back to Home with status ",
      resp,
    );

    if (resp !== "") {
      this.setState({
        isProfileRefreshing: true,
        refreshMessage:
          "Voucher redeemed successfully, please wait... refreshing your profile",
      });
      const profileEndpoint = "/Account/RenewToken"; // Replace with your exact endpoint string
      const token = auth.getToken();

      // 4. Fire the second API request sequence
      callApiGetJson(profileEndpoint, token)
        .then((updatedProfile) => {
          if (
            updatedProfile.access_token ||
            updatedProfile.access_token !== "Invalid_Access"
          )
            // Handle your updated profile data here (e.g., save to state or redux context)
            localStorage.setItem("token", updatedProfile.access_token);
          localStorage.setItem(
            "tokenexpires",
            Date.now() + updatedProfile.expires_in * 1000,
          );
          //Date.now() + data.expires_in * 1000;
          localStorage.setItem("email", updatedProfile.email);
          localStorage.setItem(
            "userinfo",
            JSON.stringify(updatedProfile.UserInfo),
          );
          this.setState({
            isProfileRefreshing: false,
            refreshMessage: "",
            isReadyForRedirect: true,
            refDemoId: resp,
          });
          console.log(
            "Profile successfully synced with renewed token and profile",
            updatedProfile,
          );
        })
        .catch((err) => {
          this.setState({
            isProfileRefreshing: false,
            refreshMessage: "Profile refresh failed. Please reload manually.",
          });
          console.error("Profile sync error:", err);
        });
      // window.location.replace(UIServerURL + "?demoid=" + resp);
    }
  }

  _pullNewsLetterLink() {
    console.log("Newsletter pull started");
    var endpoint = "/SystemSettings/GetBannerText";
    let token = auth.getToken();
    this.setState({ BannerLoading: true });

    callApiGetJson(endpoint, token).then((data) => {
      //console.log('Upcoming Events result data from API:');
      console.log("Banner Data is ", data);
      this.setState({
        SettingData: data,
        BannerLoading: false,
      });
    });
  }

  _CloseOverlay() {
    this.setState({ openDocument: false });
  }

  _CloseNewUIDocOverlay() {
    this.setState({ openNewUIDoc: false });
  }

  handleWhatsNew() {
    this.setState({ searchValueToBe: "WhatsNew", bPopupListView: true });
  }

  closeHelpModule() {
    this.setState({ isHelpModuleRequested: false });
  }

  handleFavouriteClicked() {
    this.setState({ bIsFavouriteClicked: true });
  }

  handleCorePortfolio() {
    if (this.state.Static_CP_SrchObj) {
      this.setState({ bPopUpLV_Static: true, searchValueToBe: undefined });
    } else {
      var objToBeSearched = {
        MetadataID: "PRD_65fea4c8-5d7a-4b29-91b0-e2d7bb047fc6",
        MetadataName: "Recommended Contents",
        MetadataType: "Products",
      };
      this.setState({
        Static_CP_SrchObj: objToBeSearched,
        bPopUpLV_Static: true,
        searchValueToBe: undefined,
      });
    }
  }

  handleHowtoUse() {
    this.setState({ searchValueToBe: "HowtoUse", bPopupListView: true });
  }

  handleGreenLake() {
    this.setState({ searchValueToBe: "GreenLake", bPopupListView: true });
  }

  handleEngageForBriefing() {
    /*  this.setState({
      searchValueToBe: "engageforbriefing",
      bPopupListView: true,
    }); */
    this.setState({
      searchValueToBe: "Sustainable IT solutions",
      bPopupListView: true,
    });
  }

  closeList() {
    this.setState({
      searchValueToBe: undefined,
      bPopupListView: false,
      bPopUpLV_Static: false,
      bIsFavouriteClicked: false,
      isReqViaSrchDeepLink: false,
      isDeeplinkSearchByDemoId: false,
      SrchDeepLinkParam: undefined,
    });
    this.props.history.push("/");
    // this.loadUpcomingEventsData();
  }

  loadUpcomingEventsData() {
    var endpoint = "/Events/GetUpcomingEventsByUser";
    let token = auth.getToken();
    this.setState({ showUpcomingEvtLoader: true });

    callApiGetJson(endpoint, token).then((data) => {
      //console.log('Upcoming Events result data from API:');
      //console.log(data);
      this.setState({
        UpcomingEventsData: data,
        showUpcomingEvtLoader: false,
      });
    });
    //}
  }

  loadRecentEvtsMM() {
    console.log("Load Recent Evts and MMs By Usr started ");
    var endpoint = "/AllContent/GetLastTwoEvtsMMsByUsr";
    let token = auth.getToken();
    // this.setState({ showUpcomingEvtLoader: true });

    callApiGetJson(endpoint, token).then((data) => {
      //console.log('Upcoming Events result data from API:');
      //console.log(data);
      this.setState({
        RecentEvtnMMsByUsr: data,
        isRecentEvtsMMs: true,
      });
    });
  }

  hideEvtsMMsPopup() {
    this.setState({ RecentEvtnMMsByUsr: undefined, isRecentEvtsMMs: false });
  }

  _hideUpcomingView() {
    this.setState({ showUpcomingMainView: false });
    this.loadUpcomingEventsData();
  }

  hideRedeemPopup() {
    this.setState({ isUsr_Redeem_Voucher_Req: false });
  }

  _showUpcomingView() {
    if (
      this.state.UpcomingEventsData &&
      this.state.UpcomingEventsData.length > 0
    ) {
      this.setState({ showUpcomingMainView: true });
    }
  }

  getTaxonomyData = (token) => {
    let endpoint = "/Taxonomy/GetTaxonomy";
    if (auth.getT1CategoryParam()) {
      this.setState({ showloaderforTaxonomy: true });
    }
    this.setState({ disable: true });
    callApiGetJson(endpoint, token)
      .then((data) => {
        if (data && Array.isArray(data) && data.length > 0) {
          this.setState({
            disable: false,
            hasTaxDataLoaded: true,
            loadedTaxoData: data,
            showloaderforTaxonomy: false,
          });
        }
        this.props.setTaxonomyData(data);
      })
      .catch((error) => {
        console.log("Error while fetch taxonomy data: ", error);
        this.setState({ disable: true });
      });
  };

  _logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenexpires");
    localStorage.removeItem("email");
    localStorage.removeItem("userinfo");
    localStorage.removeItem("authenticated");
    localStorage.removeItem("userimgData");
    console.log("logout fired");
    this.props.history.push("/");
  }

  onHpeDemonstrationClick = () => {
    const { disable } = this.state;
    if (!disable) this.props.history.push("/hpd");
  };

  onCustAcclPlaysClick = () => {
    const { disable } = this.state;
    if (!disable) this.props.history.push("/hpd?T1Level=CUST_ACC");
  };

  onHpeGrowth7Click = () => {
    const { disable } = this.state;
    if (!disable) this.props.history.push("/hpd?T1Level=G7");
  };

  onAIClick = () => {
    const { disable } = this.state;
    if (!disable) this.props.history.push("/hpd?T1Level=AI");
  };

  onHpeGreenLakeClick = () => {
    const { disable } = this.state;
    if (!disable) this.props.history.push("/hpd?T1Level=HPE_GL");
  };

  render() {
    var upComingEvts = new Array();
    //var DemoLaunchData = undefined;
    var showUpcomingEvtLoader;
    var icodisplay = <Console color="brand" />;
    var bShowUpcomingMainView = this.state.showUpcomingMainView;

    if (
      this.state.RecentEvtnMMsByUsr != undefined &&
      this.state.isRecentEvtsMMs
    ) {
      console.log("Recent Evts and MMs are ", this.state.RecentEvtnMMsByUsr);
      console.log(
        "Recent Evts and MMs popup can be shown ",
        this.state.isRecentEvtsMMs,
      );
    }

    var ghorChakra = "";
    if (this.state.showloaderforTaxonomy) {
      ghorChakra = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner
              size="small"
              border={[
                { side: "all", color: "yellow", size: "medium" },
                { side: "right", color: "brand", size: "medium" },
                { side: "top", color: "red", size: "medium" },
                { side: "left", color: "brand", size: "medium" },
              ]}
            />
            <Text size="small">Taking you to Taxonomy View...</Text>
          </Box>
        </Layer>
      );
    }

    if (auth.getT1CategoryParam() && !this.state.disable) {
      this.props.history.push("/hpd?T1Level=TBR");
    }

    // var BannerMsg  = this.extractBannerMsg();

    /*     if (this.state.VRNetLaunchData) {
      DemoLaunchData = this.state.VRNetLaunchData;
    } */

    var isNWLetter = false;
    var DocID = "";
    if (this.state.SettingData !== undefined) {
      var NWObj = this.state.SettingData.find(
        (st) => st.SettingName === "Newsletter",
      );
      if (NWObj !== undefined) {
        console.log("NW Object captured is ", NWObj);
        isNWLetter = true;
        DocID = NWObj.SettingValue;
      }
    }

    var isUIHelpDoc = false;
    var NewUIDocID = "";
    if (this.state.SettingData !== undefined) {
      var NUIObj = this.state.SettingData.find(
        (stt) => stt.SettingName === "New_UI_Help",
      );
      if (NUIObj !== undefined) {
        console.log("New UI Doc Object captured is ", NUIObj);
        isUIHelpDoc = true;
        NewUIDocID = NUIObj.SettingValue;
      }
    }

    var viewNewsLetter = this.state.openDocument
      ? this.state.openDocument
      : false;

    var viewNewUIDoc = this.state.openNewUIDoc
      ? this.state.openNewUIDoc
      : false;

    console.log("Is NewsLetter Fetched", isNWLetter);
    console.log("NewsLetter Document ID is ", DocID);

    //var EvtDisplay = "";
    var WaitDisplay = "";
    var uinfo = JSON.parse(localStorage.getItem("userinfo"));
    if (uinfo === null || uinfo === undefined) {
      console.log(
        "You are not coming through proper route so sorry you are kicked out",
      );
      this.kickout();
    }
    console.log(this.state.UpcomingEventsData);

    showUpcomingEvtLoader = this.state.showUpcomingEvtLoader;
    if (this.state.UpcomingEventsData != undefined) {
      var EvtDisplay = this.state.UpcomingEventsData.map((event) => {
        upComingEvts.push(event);
        //return (<Console color="brand" />{event.Event_Title});
      });
    }
    if (this.state.showUpcomingEvtLoader) {
      WaitDisplay = (
        <Box direction="row" gap="small" justify="center" align="center">
          <Spinner size="small" color="brand" />{" "}
        </Box>
      );
    }
    console.log("**Total Upcoming Events are ", upComingEvts);
    console.log("*SpinnerIndicator is", this.state.showUpcomingEvtLoader);
    console.log("** EVT DZISPLAY IS", EvtDisplay);

    var srchVal = this.state.searchValueToBe;
    var bisListTobePoppedUp = this.state.bPopupListView;

    var StaticPopUpLV = this.state.bPopUpLV_Static;
    var Static_srchObj = this.state.Static_CP_SrchObj;

    var bIsFavClicked = this.state.bIsFavouriteClicked;

    var IsReqSrchDeepLink = this.state.isReqViaSrchDeepLink;
    var isDLSearchByDemoId = this.state.isDeeplinkSearchByDemoId;
    var DeepLinkSrchParam = this.state.SrchDeepLinkParam;

    var isHlpModuleReq = this.state.isHelpModuleRequested;

    var isCustomerObj = null;
    var isCustomer = false;

    var isEmployeeObj = undefined;
    var isEmpl = false;

    var isPartberObj = undefined;
    var isPartner = false;

    // var slackSrcEmp = "";

    isCustomerObj = this.state.userInformation.UserAppRoles.find(
      (x) => x.AppRoleName === "HPE Customer",
    );

    if (isCustomerObj !== undefined) {
      isCustomer = true;
    }

    isEmployeeObj = this.state.userInformation.UserAppRoles.find(
      (x) => x.AppRoleName === "HPE Employee",
    );

    if (isEmployeeObj !== undefined) {
      isEmpl = true;
    }

    isPartberObj = this.state.userInformation.UserAppRoles.find(
      (x) => x.AppRoleName === "HPE Partner",
    );

    if (isPartberObj !== undefined) {
      isPartner = true;
    }

    /* if (isEmployeeObj != undefined && isEmpl) {
      slackSrc = "https://hpe.enterprise.slack.com/archives/C02779PMSKA";
    }

    if (isPartberObj != undefined && isPartner) {
      slackSrc = "https://hpe.enterprise.slack.com/archives/C07UW6H11LJ";
    }
 */
    var isNotification = this.state.isNotificationON;

    console.log("Is logged in User is Customer ", isCustomer);
    console.log("Logged in User is Employee", isEmpl);

    var NoticeCounter =
      auth.getNoticeCounter() != undefined && auth.getNoticeCounter() != null
        ? auth.getNoticeCounter()
        : 0;
    console.log("Notice Counter for user already hits as ", NoticeCounter);

    //var NoticeDateLimit = auth.getNoticeCounterDatelimit();
    // console.log("Notice Counter DateExpiry for user is ", NoticeDateLimit);

    var isUserNLSubs = this.state.isUsr_NLSub ? true : false;

    var isUser_Redeem_Needed = this.state.isUsr_Redeem_Voucher_Req
      ? true
      : false;
    console.log("Is User Voucher Redeem Prompt Needed ", isUser_Redeem_Needed);

    console.log("Is User NL Prompt to be shown", isUserNLSubs);

    var UEmployee = isEmpl ? "Employee" : "Not Employee";

    var RecentEvtsByUsr = undefined;
    var RecentMMsByUsr = undefined;
    var isRecentEvtMMsToBeShown = false;

    if (
      this.state.RecentEvtnMMsByUsr != undefined &&
      this.state.isRecentEvtsMMs
    ) {
      if (
        (this.state.RecentEvtnMMsByUsr.UsrRecentEvts != null &&
          this.state.RecentEvtnMMsByUsr.UsrRecentEvts.length > 0) ||
        (this.state.RecentEvtnMMsByUsr.UsrRecentMMs != null &&
          this.state.RecentEvtnMMsByUsr.UsrRecentMMs.length > 0)
      ) {
        RecentEvtsByUsr = this.state.RecentEvtnMMsByUsr.UsrRecentEvts;
        RecentMMsByUsr = this.state.RecentEvtnMMsByUsr.UsrRecentMMs;
        isRecentEvtMMsToBeShown = true;
        console.log("From Home and Ready to pop up Recent Evts n MMs by Usr");
      }
    }

    var isAnyRecent =
      RecentEvtsByUsr !== undefined || RecentMMsByUsr !== undefined
        ? true
        : false;

    console.log("Is Any Evt or MM ", isAnyRecent);
    console.log("Can Recent Evt n MM Popup be shown", isRecentEvtMMsToBeShown);

    var isReady_withRefresh = this.state.isReadyForRedirect;

    console.log("Is Refreshed User Ready to Redirect", isReady_withRefresh);
    console.log(
      "Redirect Demo Id for Refrehsed user is ",
      this.state.refDemoId,
    );
    if (
      isReady_withRefresh &&
      this.state.refDemoId !== 0 &&
      this.state.refDemoId !== ""
    ) {
      window.location.replace(UIServerURL + "?demoid=" + this.state.refDemoId);
    }

    return (
      <Box fill="vertical" align="stretch" justify="start">
        {isAnyRecent && isRecentEvtMMsToBeShown && (
          <RatingFeedback
            Evts={RecentEvtsByUsr}
            MMs={RecentMMsByUsr !== undefined ? RecentMMsByUsr : undefined}
            hide={this.hideEvtsMMsPopup}
          />
        )}
        {bShowUpcomingMainView && (
          <UserdashboardUpcomingDemos
            Demos={upComingEvts}
            hide={this._hideUpcomingView}
            //LaunchData={DemoLaunchData}
            // LaunchCallBack={this.loadVRNetLaunchInfo}
            // reloadOnchange={this.loadUpcomingEventsData}
          />
        )}
        {isUser_Redeem_Needed && (
          <RedeemPopup
            isOpen={this.state.isUsr_Redeem_Voucher_Req}
            onClose={this.hideRedeemPopup}
            onApiSuccess={this.handleRedeemSuccessData}
            userToken={auth.getToken()}
          />
        )}
        {this.state.isProfileRefreshing && (
          <Layer modal position="center" background="rgba(0,0,0,0.5)">
            <Box
              pad="large"
              background="background-front"
              round="small"
              elevation="medium"
              align="center"
              justify="center"
              gap="medium"
              width="medium"
            >
              <Spinner size="large" color="brand" />
              <Text textAlign="center" weight="bold" size="medium">
                {this.state.refreshMessage}
              </Text>
            </Box>
          </Layer>
        )}
        <Main
          overflow="auto"
          background={{ image: "url('')" }}
          flex
          align="stretch"
          justify="start"
        >
          {ghorChakra}
          {viewNewUIDoc && isUIHelpDoc && (
            <DocumentHandler
              DocumentContentRecord={undefined}
              DocTitle="New User Interface Quick Help"
              Document_ID={NewUIDocID}
              hide={this._CloseNewUIDocOverlay}
              // calledBy={this.props.calledBy}
            />
          )}
          {viewNewsLetter && isNWLetter && (
            <DocumentHandler
              DocumentContentRecord={undefined}
              DocTitle="Newsletter"
              Document_ID={DocID}
              hide={this._CloseOverlay}
              // calledBy={this.props.calledBy}
            />
          )}

          {bisListTobePoppedUp && (
            <ListView
              srchObj={undefined}
              srchVal={srchVal}
              hide={this.closeList}
              calledBy="From HomePage"
            />
          )}
          {StaticPopUpLV && Static_srchObj && (
            <ListView
              srchObj={Static_srchObj}
              srchVal={undefined}
              hide={this.closeList}
              calledBy="From HomePage"
            />
          )}
          {isHlpModuleReq && (
            <GetHelp disp={true} hide={this.closeHelpModule} />
          )}
          {IsReqSrchDeepLink &&
            DeepLinkSrchParam &&
            DeepLinkSrchParam.length > 3 && (
              <ListView
                srchObj={undefined}
                srchVal={DeepLinkSrchParam}
                hide={this.closeList}
                calledBy="ViaSearchDeeplink"
                isDemoIdSrch={isDLSearchByDemoId}
              />
            )}
          {bIsFavClicked && (
            <ListView
              srchObj={undefined}
              srchVal={undefined}
              hide={this.closeList}
              viaFav={bIsFavClicked}
              calledBy="From HomePage"
            />
          )}

          {isCustomer && isNotification && (
            <Box
              align="start"
              justify="start"
              direction="row"
              gap="small"
              pad="small"
              hoverIndicator
              animation={{ type: "pulse", duration: 2000 }}
              elevation="large"
              // onClick={this.goHome}
            >
              <Alert
                variant="outlined"
                onClose={() => {
                  this.closeNotification();
                }}
                severity="warning"
                color="success"
              >
                {/*  <AlertTitle>Information!</AlertTitle> */}
                <mark>
                  You are logged in as an HPE Customer and hereby have access to
                  a limited set of demo contents.
                </mark>
                <br />
                For more LIVE and advanced LAB in the HPE Demonstration Portal,
                please contact your HPE Approved Partner or your HPE
                representative.
              </Alert>
            </Box>
          )}
          <AppHeader
            isRefreshing={true}
            refreshCallBack={this.loadUpcomingEventsData}
          />
          <Box
            direction="column"
            width={"100%"}
            style={{ minWidth: "950px", maxWidth: "1200px" }}
            align="center"
            justify="center"
            display="flex"
            alignContent="center"
            alignSelf="center"
          >
            <Box direction="column" width={"100%"}>
              <Grid columns={["3/4", "1/4"]} gap="xsmall" responsive={true}>
                <Box
                  align="center"
                  justify="start"
                  direction="column"
                  pad="xsmall"
                  //flex="grow"

                  style={{
                    minWidth: "690px",
                    maxWidth: "800px",
                    width: "95%",
                  }}
                >
                  {/* <SearchHandler hide={this._hideSearch} Prods={null} /> */}
                  {/*               <Heading
                margin="none"
                color="active-text"
                level="3"
                size="medium"
              >
                Welcome, {uinfo ? uinfo.FirstName + " " + uinfo.LastName : "-"}                
                &nbsp;&nbsp;&nbsp;
                <SearchAdvanced size="medium" />               
              </Heading> */}

                  <Box
                    align="start"
                    justify="start"
                    elevation="none"
                    responsive
                    // margin={{ top: "medium" }}
                    pad="xsmall"
                  >
                    <Heading
                      margin="none"
                      color="active-text"
                      level="4"
                      size="medium"
                    >
                      Welcome,{" "}
                      {uinfo ? uinfo.FirstName + " " + uinfo.LastName : "-"}
                      {/*  &nbsp;&nbsp;&nbsp;
                <SearchAdvanced size="medium" /> */}
                    </Heading>
                    <SearchHandler hide={this._hideSearch} Prods={null} />
                    <Grid
                      rows="small"
                      gap="small"
                      columns={["1/4", "1/4", "1/4", "1/4"]}
                    >
                      <Card
                        pad={{ top: "medium", horizontal: "small" }}
                        background={{ color: "active-background", dark: false }}
                        justify="start"
                        gap="small"
                        // onClick={this.handleHowtoUse}
                        onClick={this.onHpeDemonstrationClick}
                        hoverIndicator={{ color: "dark-1", opacity: "medium" }}
                      >
                        <Catalog size="medium" color="active-text" />
                        <Box align="stretch" justify="start" flex="shrink">
                          {/* <Heading
                        size="small"
                        level="4"
                        margin={{ top: "none", bottom: "medium" }}
                      > */}
                          <Text size="large" color="black">
                            All demos
                          </Text>
                          {/* </Heading> */}
                        </Box>
                        <Paragraph color="text-strong" size="small">
                          All demos by categories from catalog
                        </Paragraph>
                      </Card>
                      <Card
                        pad={{
                          top: "medium",
                          horizontal: "small",
                          //vertical: "small",
                          //bottom: "medium",
                        }}
                        background={{ color: "active-background", dark: false }}
                        justify="start"
                        gap="small"
                        onClick={this.handleWhatsNew}
                        hoverIndicator={{ opacity: "medium", color: "dark-1" }}
                        height="small"
                      >
                        <New size="medium" color="active-text" />
                        <Box
                          align="stretch"
                          justify="start"
                          flex="shrink"
                          // margin={{ bottom: "medium" }}
                        >
                          {/* <Heading
                        size="small"
                        level="4"
                        margin={{ top: "none", bottom: "medium" }}
                      > */}
                          <Text size="large" color="black">
                            What is New ?
                          </Text>
                          {/* </Heading> */}
                        </Box>
                        <Paragraph color="text-strong" size="small">
                          Browse the latest published demonstrations and
                          recordings
                        </Paragraph>
                      </Card>
                      <Card
                        pad={{ top: "medium", horizontal: "small" }}
                        background={{ color: "active-background", dark: false }}
                        justify="start"
                        gap="small"
                        onClick={this.handleCorePortfolio}
                        hoverIndicator={{ color: "dark-1", opacity: "medium" }}
                      >
                        <Like size="medium" color="active-text" />
                        <Box
                          align="stretch"
                          justify="start"
                          flex="shrink"
                          // margin={{ bottom: "medium" }}
                        >
                          {/* <Heading
                        size="small"
                        level="4"
                        margin={{ top: "none", bottom: "medium" }}
                      > */}
                          <Text size="large" color="black">
                            Recommended
                          </Text>
                          {/* </Heading> */}
                        </Box>

                        <Paragraph color="text-strong" size="small">
                          Quick access to a recommended content selection
                        </Paragraph>
                      </Card>

                      <Card
                        pad={{ top: "medium", horizontal: "small" }}
                        background={{ color: "active-background", dark: false }}
                        justify="start"
                        gap="small"
                        onClick={this.handleFavouriteClicked}
                        hoverIndicator={{ color: "dark-1", opacity: "medium" }}
                      >
                        <Favorite size="medium" color="active-text" />
                        <Box align="stretch" justify="start" flex="shrink">
                          {/* <Heading
                        size="small"
                        level="4"
                        margin={{ top: "none", bottom: "none" }}
                      > */}
                          <Text size="large" color="black">
                            My Favorites
                          </Text>
                          {/* </Heading> */}
                        </Box>
                        <Paragraph color="text-strong" size="small">
                          Quick access to your favorite content
                        </Paragraph>
                      </Card>
                      <Card
                        justify="start"
                        gap="small"
                        pad={{
                          horizontal: "small",
                          bottom: "small",
                          top: "large",
                        }}
                        background={{
                          dark: true,
                          image: this.state.disable
                            ? `url(${allDemosbg})`
                            : `url(${allDemosbg})`,
                        }}
                        style={{
                          color: "#01A982",
                          backgroundImage: this.state.disable
                            ? `url(${Alldemos})`
                            : `url(${Alldemos})`,
                          backgroundSize: this.state.disable
                            ? "cover"
                            : "cover",
                          backgroundPosition: this.state.disable
                            ? "end"
                            : "start",
                          transition: 100,
                        }}
                        onClick={this.onCustAcclPlaysClick}
                        hoverIndicator={!this.state.disable}
                      >
                        <Heading
                          size="small"
                          level="3"
                          truncate={false}
                          margin="none"
                          color="white"
                        >
                          Customer Acceleration Plays
                        </Heading>
                      </Card>
                      <Card
                        justify="start"
                        gap="small"
                        pad={{
                          horizontal: "small",
                          bottom: "small",
                          top: "large",
                        }}
                        background={{
                          dark: true,
                          image: this.state.disable
                            ? `url(${PartnerSolutions})`
                            : `url(${PartnerSolutions})`,
                          color: "brand",
                        }}
                        style={{
                          color: "#01A982",
                          backgroundImage: this.state.disable
                            ? `url(${PartnerSolutions})`
                            : `url(${PartnerSolutions})`,
                          backgroundSize: this.state.disable
                            ? "cover"
                            : "cover",
                          backgroundPosition: this.state.disable
                            ? "end"
                            : "start",
                          transition: 100,
                        }}
                        onClick={this.onHpeGrowth7Click}
                        hoverIndicator={!this.state.disable}
                      >
                        <Heading
                          size="small"
                          level="3"
                          truncate={false}
                          margin="none"
                          color="white"
                        >
                          Partner Solutions
                        </Heading>
                      </Card>
                      <Card
                        justify="start"
                        gap="small"
                        pad={{
                          horizontal: "small",
                          bottom: "small",
                          top: "large",
                        }}
                        background={{
                          dark: true,
                          image: `url(${GreenLakeDemos})`,
                          color: "brand",
                        }}
                        style={{
                          color: "#01A982",
                          backgroundImage: this.state.disable
                            ? `url(${GreenLakeDemos})`
                            : `url(${GreenLakeDemos})`,
                          backgroundSize: this.state.disable
                            ? "cover"
                            : "cover",
                          backgroundPosition: this.state.disable
                            ? "end"
                            : "start",
                          transition: 100,
                        }}
                        onClick={this.onHpeGreenLakeClick}
                        hoverIndicator={!this.state.disable}
                      >
                        <Heading
                          size="small"
                          level="3"
                          truncate={false}
                          margin="none"
                          color="white"
                        >
                          GreenLake by HPE
                        </Heading>
                      </Card>
                      <Card
                        justify="start"
                        gap="small"
                        pad={{
                          horizontal: "small",
                          bottom: "small",
                          top: "large",
                        }}
                        background={{
                          dark: true,
                          image: `url(${AIdemos})`,
                          color: "brand",
                        }}
                        style={{
                          color: "#01A982",
                          backgroundImage: this.state.disable
                            ? `url(${AIdemos})`
                            : `url(${AIdemos})`,
                          backgroundSize: this.state.disable
                            ? "cover"
                            : "cover",
                          backgroundPosition: this.state.disable
                            ? "end"
                            : "start",
                          transition: 100,
                        }}
                        onClick={this.onAIClick}
                        hoverIndicator={!this.state.disable}
                      >
                        <Heading
                          size="small"
                          level="3"
                          truncate={false}
                          margin="none"
                          color="white"
                        >
                          Artificial Intelligence
                        </Heading>
                      </Card>
                    </Grid>
                  </Box>
                </Box>

                <Box
                  align="center"
                  justify="center"
                  //onClick={() => {}}
                  //fill="horizontal"
                  responsive
                  pad="small"
                  gap="small"
                  margin={{ right: "small", left: "small" }}
                  border={{ side: "left", style: "dotted" }}
                  width={"90%"}
                  style={{ minWidth: "200px" }}
                >
                  <Box
                    align="center"
                    justify="end"
                    direction="row"
                    fill="horizontal"
                  >
                    <Box
                      align="start"
                      justify="start"
                      pad="medium"
                      direction="row"
                      fill="horizontal"
                      margin={{ left: "none" }}
                    >
                      {/* <WeChat size="xlarge" color="brand" /> */}
                      <Button
                        size="xlarge"
                        label="chatbot"
                        icon={<Android />}
                        reverse
                        secondary={false}
                        primary
                        color="brand"
                        onClick={this._openchatApplet}
                        style={{ borderRadius: "12px" }} // Adds the rounded corners
                      />
                    </Box>
                  </Box>
                  <Card
                    fill="horizontal"
                    //width="400px"
                    //flex="shrink"
                    background={{ color: "active-background" }}
                    //margin={{ top: "large" }}
                  >
                    <CardHeader
                      align="center"
                      direction="row"
                      justify="between"
                      gap="none"
                      pad="small"
                    >
                      <Text size="large" weight={500} color="active-text">
                        Quick Links:
                      </Text>
                    </CardHeader>
                    <CardBody
                      pad="small"
                      overflow="hidden"
                      // flex="grow"
                      // width="100%"
                    >
                      <Anchor
                        label="View-Newsletter"
                        color="brand"
                        onClick={this._handleDocumentView}
                      />
                      <br />
                      {/* <Text color="brand">View newsletter</Text> */}
                      <Anchor
                        label="Propose new content"
                        color="brand"
                        onClick={() =>
                          (window.location =
                            "mailto:contacthpedemoportal@hpe.com?subject=HPE%20Demo%20Portal%20New%20Content%20Request")
                        }
                      />
                      <br />
                      {/* <Text color="brand">Propose new content</Text> */}
                      {isEmployeeObj != undefined && isEmpl && (
                        <Anchor
                          label="Demo Portal community"
                          color="brand"
                          onClick={this.OpenSlackHDPEmp}
                        />
                      )}
                      {isPartberObj != undefined && isPartner && (
                        <Anchor
                          label="Demo Portal community"
                          color="brand"
                          onClick={this.OpenSlackHDPPartner}
                        />
                      )}
                      <br />
                      <Anchor
                        label="HPE-Psnow"
                        color="brand"
                        onClick={this.OpenPSNow}
                      />
                      <Anchor
                        label="HPE-TechPro"
                        color="brand"
                        onClick={this.OpenTechPro}
                      />
                      <br />
                      <Anchor
                        label="Need Help ?"
                        color="brand"
                        onClick={this._openchatApplet_Link}
                        // onClick={() =>
                        //   (window.location =
                        //     "mailto:sdp.demo.support.staff@hpe.com?subject=Need%20Help%20!!")
                        // }
                      />
                      <Box>
                        <Anchor
                          label="Rating & Feedback"
                          color="brand"
                          // disabled={!this.state.isRecentEvtsMMs}
                          onClick={this.handleRatingFeedbackClick}
                        />
                      </Box>
                      <Anchor
                        label="How to use"
                        color="brand"
                        onClick={this.handleHowtoUse}
                        // onClick={() =>
                        //   (window.location =
                        //     "mailto:sdp.demo.support.staff@hpe.com?subject=Need%20Help%20!!")
                        // }
                      />
                    </CardBody>
                  </Card>
                  <Card
                    fill="horizontal"
                    margin={{ top: "medium" }}
                    background={{ color: "active-background" }}
                    //Yelevation="medium"
                    // animation={{ type: "pulse", duration: 1000 }}
                    onClick={this._showUpcomingView}
                  >
                    <CardHeader
                      align="center"
                      direction="row"
                      justify="between"
                      gap="none"
                      pad="small"
                    >
                      <Text size="large" weight={500} color="active-text">
                        My demo event(s):
                      </Text>
                    </CardHeader>
                    <CardBody pad="small" overflow="hidden" flex="shrink">
                      {!showUpcomingEvtLoader && upComingEvts.length === 0 && (
                        <Text size="small" color="brand">
                          No demo event(s) scheduled or running for you.
                        </Text>
                      )}
                      {!showUpcomingEvtLoader && upComingEvts.length > 0 && (
                        <List
                          data={upComingEvts}
                          border={true}
                          secondaryKey={(item) => <Console color="brand" />}
                          primaryKey={(item) => (
                            <Text
                              textAlign="start"
                              size="small"
                              color="brand"
                              truncate={true}
                            >
                              {item.Event_Title}
                            </Text>
                          )}
                          step={2}
                          //show={{ page: 7 }}
                          paginate
                        ></List>
                      )}
                      {showUpcomingEvtLoader && (
                        <Box
                          direction="row"
                          gap="small"
                          justify="center"
                          align="center"
                        >
                          <Spinner size="small" color="brand" />{" "}
                        </Box>
                      )}
                    </CardBody>
                  </Card>
                </Box>
              </Grid>
            </Box>
          </Box>
          {this.state.bOpenChatViaLink && (
            <ChatappletN
              hide={this.hidechat}
              UType={UEmployee}
              uname={uinfo.FirstName}
              uemail={uinfo.EmailAddress}
              needhelp={true}
            />
          )}
          {this.state.bOpenChat && (
            <ChatappletN
              hide={this.hidechat}
              UType={UEmployee}
              uname={uinfo.FirstName}
              uemail={uinfo.EmailAddress}
              needhelp={false}
            />
          )}
        </Main>
      </Box>
    );
  }
}

const mapStateToProps = function (state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTaxonomyData: (data) => {
      dispatch(setTaxonomyDataRequest(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
